Belimo.Cart = {
    add(product) {
        $(document).trigger('cart-add', [product]);
    },

    remove(product) {
        $(document).trigger('cart-remove', [product]);
    },

    update(products) {
        $(document).trigger('cart-update', [products]);
    },

    empty() {
        $(document).trigger('cart-empty');
    },

    rename(name) {
        $(document).trigger('cart-rename', name);
    },

    updateFromRemote(langIsoCode) {
        const requestUriPrefix = window && window.countryCode ? window.countryCode : '';
        const requestUrl = requestUriPrefix + '/shop/' + langIsoCode + '/cart/miniCart/1';

        $.ajax({
            url: requestUrl,
            dataType: 'json',
            method: 'GET'
        }).done((response) => {
            if (!response) return;
            if (response.products) {
                Belimo.Cart.update(response.products);
            } else if (response.errors && response.errors.length > 0) {
                console.error(response.errors[0]);
            }
        }).fail((xhr) => {
            console.error('Failed to update mini cart.', xhr.responseText);
        });
    },

    submit(url, data) {
        $.ajax({
            method: 'POST',
            url,
            dataType: 'json',
            data,
            success(response) {
                const layer = $(response.addToCartLayer);
                const checkout = layer.find('.btn-primary');
                const newconfigfromscratch = layer.find('.btn-third');
                const cancel = layer.find('.btn-default');
                const buttons = [];

                Belimo.Cart.update(response.cartData.products || []);

                buttons.push({
                    label: checkout.text(),
                    type: 'button',
                    callback() {
                        location.href = checkout.attr('href');
                    }
                });

                if (response.cartData.configurableProduct) {
                    buttons.push({
                        label: newconfigfromscratch.text(),
                        type: 'button',
                        callback() {
                            location.href = newconfigfromscratch.attr('href');
                        }
                    });
                }

                buttons.push({
                    label: cancel.text(),
                    type: 'reset',
                    callback: Belimo.Modal.close
                });

                Belimo.Modal.open(layer.find('.add-to-cart-item'), buttons);
            }
        });
    }
};
